import React from 'react';
import { HeartIcon, MessageCircleIcon } from 'lucide-react';
interface Chat {
  handle: string;
  msgs: {
    from: 'them' | 'me';
    text: string;
  }[];
}
const CHATS: Chat[] = [{
  handle: 'marta.hockey10',
  msgs: [{
    from: 'them',
    text: 'tía acabo de terminar el tomo de táctica 😭'
  }, {
    from: 'them',
    text: 'las transiciones ataque-defensa me han volado la cabeza'
  }, {
    from: 'me',
    text: '¿te está sirviendo entonces?'
  }, {
    from: 'them',
    text: 'muchísimo, es lo mejor que me he comprado este año 🔥'
  }]
}, {
  handle: 'nerea_fh',
  msgs: [{
    from: 'them',
    text: 'el planificador de 3 meses es una locura'
  }, {
    from: 'them',
    text: 'por fin sé qué entrenar cada semana'
  }, {
    from: 'me',
    text: '¿y las planillas se usan fácil?'
  }, {
    from: 'them',
    text: 'sí sí, todo calculado. lo abrí y a jugar 💪'
  }]
}, {
  handle: 'alba.gk1',
  msgs: [{
    from: 'them',
    text: 'soy portera y el tomo 5 me ha salvado'
  }, {
    from: 'them',
    text: 'lo del achique de ángulos no lo tenía tan claro'
  }, {
    from: 'me',
    text: '¿lo recomiendas para porteras?'
  }, {
    from: 'them',
    text: '100%. ojalá lo hubiera tenido antes 🧤'
  }]
}];
function ChatCard({
  chat
}: {
  chat: Chat;
}) {
  return <div className="w-[280px] shrink-0 snap-center overflow-hidden rounded-2xl border border-white/10 bg-white" data-id="element-152" data-mp="3bzrdv9qikwn7">
      <div className="flex items-center gap-2 border-b border-gray-200 px-3 py-2.5" data-id="element-153" data-mp="dinhyvfgrjq3">
        <div className="h-8 w-8 rounded-full bg-gradient-to-tr from-hockey-pink to-amber-400" data-id="element-154" data-mp="8jakzhuvow9s" />
        <div className="min-w-0" data-id="element-155" data-mp="3jy2taeycddj">
          <p className="truncate text-[13px] font-semibold text-gray-900" data-id="element-156" data-mp="3iwpezagresn">{chat.handle}</p>
          <p className="text-[11px] text-gray-400" data-id="element-157" data-mp="3ur0q3qro5zih">Instagram · Mensajes</p>
        </div>
      </div>
      <div className="space-y-1.5 bg-gray-50 px-3 py-3" data-id="element-158" data-mp="2oaf7siqhh4p4">
        {chat.msgs.map((m, i) => <div key={i} className={`flex ${m.from === 'me' ? 'justify-end' : 'justify-start'}`} data-id="element-159" data-mp="2jasw4dqazwif" data-mpi={i}>
            <span className={`max-w-[78%] rounded-2xl px-3 py-1.5 text-[13px] leading-snug ${m.from === 'me' ? 'rounded-br-sm bg-hockey-pink text-white' : 'rounded-bl-sm bg-gray-200 text-gray-900'}`} data-id="element-160" data-mp="1bbdeydf7p0ep">
              {m.text}
            </span>
          </div>)}
      </div>
      <div className="flex items-center gap-4 border-t border-gray-200 px-3 py-2 text-gray-400" data-id="element-161" data-mp="rnnwiwt60ci5">
        <HeartIcon className="h-4 w-4" data-id="element-162" data-mp="wecmu8t3z3fp" />
        <MessageCircleIcon className="h-4 w-4" data-id="element-163" data-mp="wfe793w0l2a3" />
      </div>
    </div>;
}
export function InstagramReviews() {
  return <section className="py-8" data-id="element-164" data-mp="iosp5hedwwd9">
      <div className="px-4" data-id="element-165" data-mp="nm2b2n2kepwc">
        <h2 className="text-center font-display text-2xl leading-tight text-white" data-id="element-166" data-mp="nl9e2dterere">
          Deja de jugar a mitad de tu potencial
        </h2>
        <p className="mx-auto mt-3 max-w-sm text-center text-[15px] text-white/70" data-id="element-167" data-mp="8qv0issm4xk4">
          Cada partido que juegas sin un método es una oportunidad perdida de mejorar. Las jugadoras
          que dan el salto no entrenan más… entrenan con sistema. Este es el tuyo.
        </p>
      </div>

      <div className="no-scrollbar mt-6 flex snap-x snap-mandatory gap-3 overflow-x-auto px-4 pb-2" data-id="element-168" data-mp="3m7oqlvsun7eo">
        {CHATS.map(c => <ChatCard key={c.handle} chat={c} data-id="element-169" data-mp="3v6k1vmar37ou" />)}
      </div>
      <p className="mt-1 text-center text-[11px] text-white/40" data-id="element-170" data-mp="3v58w5gxqvpv3">← Desliza para ver más opiniones →</p>
    </section>;
}